import { createSlice } from '@reduxjs/toolkit';

import utils from 'lib/utils';
import { circleService } from 'services';

// BFC-9035: Global Circle Filter for Control Tower listings.
// selectedCircleIds = [] means "All Circles" (no circle filter is sent to the API).
// selectedCircleIds is persisted to localStorage by its own persistReducer in store.ts (see lib/circleFilterStorage).
const slice = createSlice({
  name: 'circleFilter',
  initialState: { circles: [], selectedCircleIds: [] },
  reducers: {
    setCircles(state, action) {
      state.circles = action.payload || [];
    },
    setSelectedCircleIds(state, action) {
      state.selectedCircleIds = action.payload || [];
    },
  },
});

const fetchCircles = () => async (dispatch) => {
  try {
    const resData = await circleService.fetchAllBiofuelCircles();
    dispatch(slice.actions.setCircles(resData));
  } catch (err) {
    utils.displayErrors(err);
  }
};

// Extra listing filter param for the selected circles; {} when "All Circles" is selected.
const getCircleFilterParams = (selectedCircleIds) =>
  selectedCircleIds?.length ? { circle_ids: selectedCircleIds.join(',') } : {};

const actions = {
  ...slice.actions,
  fetchCircles,
};

const selectors = {
  selectCircles: (state) => state.circleFilter?.circles || [],
  selectSelectedCircleIds: (state) => state.circleFilter?.selectedCircleIds || [],
};

export { actions, selectors, getCircleFilterParams };

export default slice.reducer;
